"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarSection = exports.SidebarSectionDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var sidebar_section_header_1 = require("./sidebar-section-header");
exports.SidebarSectionDefaultProps = {
  onToggle: function (id) {},
  isLoading: false,
  canToggle: true,
  isCurrent: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), function (_a) {
    var hasBorder = _a.hasBorder;
    return hasBorder && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-top: 1px solid ", ";\n    "], ["\n      border-top: 1px solid ", ";\n    "])), theme_1.theme.COLOR('line-sidebar'));
  }, function (_a) {
    var isCurrent = _a.isCurrent;
    return isCurrent && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      /* background: linear-gradient(to top, #FFF 0%, ", " 60px, ", " 100%); */\n    "], ["\n      /* background: linear-gradient(to top, #FFF 0%, ", " 60px, ", " 100%); */\n    "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('app-chrome'));
  }, function (_a) {
    var isCurrent = _a.isCurrent,
      hasBorder = _a.hasBorder;
    return isCurrent && hasBorder && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      /* background: ", ";\n      border-top-color: ", ";  */\n    "], ["\n      /* background: ", ";\n      border-top-color: ", ";  */\n    "])), theme_1.theme.COLOR('light'), theme_1.theme.COLOR('line-sidebar-subtle'));
  })
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: (0, styled_components_1.default)(sidebar_section_header_1.SidebarSectionHeader)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Body: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
var SidebarSection = function (props) {
  var className = props.className,
    isOpen = props.isOpen,
    id = props.id,
    name = props.name,
    icon = props.icon,
    canToggle = props.canToggle,
    hasBorder = props.hasBorder,
    children = props.children,
    onToggle = props.onToggle,
    isLoading = props.isLoading,
    isCurrent = props.isCurrent,
    hasChildren = props.hasChildren;
  var showBody = isOpen;
  var onClick = hasChildren ? onToggle : props.onClick;
  return react_1.default.createElement(My.Container, {
    isCurrent: isCurrent,
    hasBorder: hasBorder,
    className: className
  }, react_1.default.createElement(My.Header, {
    isExpandable: canToggle && hasChildren,
    isCurrent: isCurrent,
    isLoading: isLoading,
    isOpen: isOpen,
    icon: icon,
    onClick: function () {
      onClick(id);
    }
  }, name), showBody && react_1.default.createElement(My.Body, null, children));
};
exports.SidebarSection = SidebarSection;
exports.SidebarSection.defaultProps = exports.SidebarSectionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;